'use strict';

exports.__esModule = true;
exports.default = {
  BLUE: 'blue',
  WHITE: 'white'
};
//# sourceMappingURL=MessengerColor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/MessengerColor.js
// module id = 450
// module chunks = 198517197184460